import AppLayout from "../../components/AppLayout";
import TableBotStates from "../../components/tables/TableBotStates";
import useBotStates from "../../hooks/pages/admin/useBotStates";

const BotStates = () => {
  const { isLoading, bots } = useBotStates();
  return (
    <AppLayout
      isLoading={isLoading}
      title="Panel de Administrador"
      tabType="admin"
      tab={0}
    >
      <div className="row  m-0 p-0">
        <div>
          <TableBotStates data={bots} />
        </div>
      </div>
    </AppLayout>
  );
};

export default BotStates;
